import React, { useState } from "react";
import { useLocation } from "react-router-dom";

const PoliticAndTerrorisCompany = ({ refPoliticalExposed }) => {
  const data = useLocation();
  const [PoliticalInformationCompany, setPoliticalInformationCompany] =
    useState({
      politicallyExposed:
        data.state.data.PoliticalInformationCompany.politicallyExposed,
      terrorismVerification:
        data.state.data.PoliticalInformationCompany.terrorismVerification,
    });
  return (
    <div className="section">
      <div className="tittleupdatebox">
        <p className="tittleupdate">
          Información política y verificación de terrorismo
        </p>
      </div>
      <div className="displayinputupdatebox">
        <div className="inputboxupdate">
          <label className="tittleinputupdate">
            Es políticamente expuesto:
          </label>
          <select
            ref={refPoliticalExposed}
            className="inputupdate"
            defaultValue={PoliticalInformationCompany.politicallyExposed}
            onChange={(e) =>
              setPoliticalInformationCompany({
                ...PoliticalInformationCompany,
                politicallyExposed: e.target.value,
              })
            }
          >
            <option value="No">No</option>
            <option value="Si">Si</option>
          </select>
        </div>
      </div>
    </div>
  );
};

export default PoliticAndTerrorisCompany;
